import { httpClient } from '@/lib/http-client'

export const domainsApi = {
    getAll: (params?: any) => httpClient.get('/domains', { params }),
    create: (data: any) => httpClient.post('/domains', data),
    update: (id: string, data: any) => httpClient.put(`/domains/${id}`, data),
    delete: (id: string) => httpClient.delete(`/domains/${id}`),
    importData: (form: FormData) =>
        httpClient.post('/domains/import', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
    exportUrl: (format: string) => `/api/domains/export?format=${format}`,
}
